// import React from 'react';
// import { observer } from 'mobx-react';
// // include ECharts main module
// import echarts, { ECharts } from 'echarts/lib/echarts';
// // include bar chart
// import 'echarts/lib/chart/bar';
// // include tooltip and title component
// import 'echarts/lib/component/tooltip';
// import 'echarts/lib/component/title';
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// import { ResponsiveScatterPlot, ResponsiveScatterPlotCanvas } from '@nivo/scatterplot';
// import SettingsStore from '../../stores/SettingsStore';
// import LineChartStore from '../../stores/charts/LineChartStore';
// export interface LineChartProps {
//   inPopup?: boolean;
//   store: LineChartStore;
//   settings: SettingsStore;
// }
// @observer
// export default class LineChart extends React.Component<LineChartProps> {
//   private _ref: HTMLDivElement | null = null;
//   private _chart: ECharts | null = null;
//   componentDidMount() {
//     if (this._ref) {
//       this._chart = echarts.init(this._ref);
//     }
//   }
//   render() {
//     // if (this._chart) {
//     //   const { store } = this.props;
//     //   if (store.lines.length > 0) {
//     //     this._chart.setOption({
//     //       title: {
//     //         text: store.id,
//     //       },
//     //       tooltip: {},
//     //       xAxis: {
//     //         type: 'value',
//     //         data: store.lines[0].data
//     //           .map(([x]) => x),
//     //       },
//     //       yAxis: {
//     //         type: 'value',
//     //       },
//     //       series: store.lines
//     //         .map(({ id, data}) => ({ type: 'line', name: id, data })),
//     //     });
//     //   }
//     // }
//     // return <div ref={(el) => (this._ref = el)} style={{ width: '100%', height: '100%' }} />;
//     return (
//       <ResponsiveScatterPlotCanvas
//         data={toJS(store.lines)} // forces component to refresh when chart data are modified (even deeply)
//         margin={{
//           top: 25,
//           right: 110,
//           bottom: 50,
//           left: 60,
//         }}
//         xScale={{
//           type: 'linear',
//           min: 'auto',
//           max: 'auto',
//         }}
//         yScale={{
//           type: 'linear',
//           min: 'auto',
//           max: 'auto',
//         }}
//         theme={{
//           markers: {
//             textColor: mutedColor,
//           },
//           legends: {
//             text: {
//               fill: mutedColor,
//             },
//           },
//           labels: {
//             text: {
//               fill: inverseColor,
//             },
//           },
//           tooltip: {
//             container: {
//               border: '1px solid #666',
//               backgroundColor: color,
//               color: mutedColor,
//             },
//           },
//           axis: {
//             ticks: {
//               line: {
//                 fill: 'red',
//               },
//               text: {
//                 fill: mutedColor,
//               },
//             },
//             legend: {
//               text: {
//                 fill: inverseColor,
//               },
//             },
//           },
//         }}
//         axisBottom={{
//           tickSize: 5,
//           tickPadding: 5,
//           tickRotation: 0,
//           legend: store.xLegend,
//           legendOffset: 40,
//           legendPosition: 'middle',
//         }}
//         axisLeft={{
//           tickSize: 5,
//           tickPadding: 5,
//           tickRotation: 0,
//           legend: store.yLegend,
//           legendOffset: -50,
//           legendPosition: 'middle',
//         }}
//         legends={[
//           {
//             anchor: 'bottom-right',
//             direction: 'column',
//             itemTextColor: inverseColor,
//             justify: false,
//             translateX: 100,
//             translateY: 0,
//             itemsSpacing: 0,
//             itemDirection: 'left-to-right',
//             itemWidth: 80,
//             itemHeight: 20,
//             itemOpacity: 0.9,
//             symbolSize: 12,
//             symbolShape: 'circle',
//             effects: [
//               {
//                 on: 'hover',
//                 style: {
//                   itemBackground: 'rgba(0, 0, 0, .03)',
//                   itemOpacity: 1,
//                 },
//               },
//             ],
//           },
//         ]}
//       />
//     );
//   }
// }
import React from 'react';
import { Line, ResponsiveLine } from '@nivo/line';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
let LineChart = class LineChart extends React.Component {
    render() {
        const { width = 600, height = 250, inPopup = false, store, settings } = this.props;
        const color = (settings.nightMode && !inPopup) ? '#222' : '#fff';
        const inverseColor = (settings.nightMode && !inPopup) ? '#fff' : '#222';
        const mutedColor = (settings.nightMode && !inPopup) ? '#999' : '#666';
        // tslint:disable-next-line:variable-name
        const Chart = inPopup ? ResponsiveLine : Line;
        const chartProps = inPopup ? {} : { width, height };
        return (React.createElement(Chart, Object.assign({}, chartProps, { data: toJS(store.lines), colors: "dark2", margin: {
                top: 25,
                right: 110,
                bottom: 50,
                left: 60,
            }, xScale: {
                type: 'linear',
                min: 'auto',
                max: 'auto',
            }, yScale: {
                type: 'linear',
                min: 'auto',
                max: 'auto',
            }, theme: {
                markers: {
                    textColor: mutedColor,
                },
                legends: {
                    text: {
                        fill: mutedColor,
                    },
                },
                labels: {
                    text: {
                        fill: inverseColor,
                    },
                },
                tooltip: {
                    container: {
                        border: '1px solid #666',
                        backgroundColor: color,
                        color: mutedColor,
                    },
                },
                axis: {
                    ticks: {
                        line: {
                            fill: 'red',
                        },
                        text: {
                            fill: mutedColor,
                        },
                    },
                    legend: {
                        text: {
                            fill: inverseColor,
                        },
                    },
                },
            }, axisBottom: {
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: store.xLegend,
                legendOffset: 40,
                legendPosition: 'middle',
            }, axisLeft: {
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: store.yLegend,
                legendOffset: -50,
                legendPosition: 'middle',
            }, dotSize: 8, dotColor: "inherit:darker(0.3)", dotBorderWidth: 2, dotBorderColor: "#fff", enableDotLabel: !settings.nightMode, legends: [
                {
                    anchor: 'bottom-right',
                    direction: 'column',
                    itemTextColor: inverseColor,
                    justify: false,
                    translateX: 100,
                    translateY: 0,
                    itemsSpacing: 0,
                    itemDirection: 'left-to-right',
                    itemWidth: 80,
                    itemHeight: 20,
                    itemOpacity: 0.9,
                    symbolSize: 12,
                    symbolShape: 'circle',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemBackground: 'rgba(0, 0, 0, .03)',
                                itemOpacity: 1,
                            },
                        },
                    ],
                },
            ] })));
    }
};
LineChart = __decorate([
    observer
], LineChart);
export default LineChart;
